import { render, staticRenderFns } from "./SubmenuGrid.vue?vue&type=template&id=94b9b0ee&scoped=true"
import script from "./SubmenuGrid.vue?vue&type=script&lang=js"
export * from "./SubmenuGrid.vue?vue&type=script&lang=js"
import style0 from "./SubmenuGrid.vue?vue&type=style&index=0&id=94b9b0ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b9b0ee",
  null
  
)

export default component.exports